import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=ca6a3fa2&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=ca6a3fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6a3fa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca6a3fa2')) {
      api.createRecord('ca6a3fa2', component.options)
    } else {
      api.reload('ca6a3fa2', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=ca6a3fa2&scoped=true&", function () {
      api.rerender('ca6a3fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pAH2WD1tW1Z9/JS/comp/Voucher.vue"
export default component.exports